import MUIDataTable from 'mui-datatables'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { Button, Container } from 'src/modules/ui'
import { formatDate } from 'src/utils'

const ScheduledOrderList = ({ orders, onChangeScheduledOrderStatus }) => {
  const history = useHistory()

  const data = orders.map(order => ({
    ...order,
    startDate: formatDate(order.start_date),
    endDate: order.endDate ? formatDate(order.endDate) : null,
  }))

  const columns = [
    {
      name: 'frequency',
      label: 'Frequency',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'startDate',
      label: 'Starting',
      options: {
        filter: false,
        sort: true,
        sortDirection: 'asc',
      },
    },
    {
      name: 'endDate',
      label: 'Ending',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'repeatDays',
      label: 'Repeats On',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: '',
      label: '',
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: dataIndex => {
          const order = orders[dataIndex]
          return (
            <>
              <Button
                variant="contained"
                color="primary"
                onClick={() =>
                  history.push(`/purchasing/drafts/${order.draftOrderId}/edit`)
                }
              >
                View Order
              </Button>
              {order.status !== 'paused' ? (
                <Button
                  variant="contained"
                  style={{ marginLeft: '1rem' }}
                  color="primary"
                  onClick={() => onChangeScheduledOrderStatus(order, 'paused')}
                >
                  Pause
                </Button>
              ) : null}
              {order.status === 'paused' ? (
                <Button
                  variant="contained"
                  style={{ marginLeft: '1rem' }}
                  color="primary"
                  onClick={() => onChangeScheduledOrderStatus(order, 'active')}
                >
                  Resume
                </Button>
              ) : null}
            </>
          )
        },
      },
    },
  ]

  const options = {
    download: false,
    elevation: 0,
    print: false,
    responsive: 'simple',
    rowsPerPage: 20,
    rowsPerPageOptions: [20, 50, 100],
    selectableRows: 'none',
    viewColumns: false,
  }
  console.log(columns, data, options)
  return (
    <Container muiTable>
      <MUIDataTable
        columns={columns}
        data={data}
        options={options}
        title="Repeating Orders"
      />
    </Container>
  )
}

export default ScheduledOrderList
